module.exports = __webpack_public_path__ + "7b8cb7a6c572be8884d0e2a0d422c8b6.MP3";